const APP_ICON_CDN_BASE = "https://genefied-saas-partner.s3.ap-south-1.amazonaws.com";

export const normalizeIconUrl = (icon) => {
  if (!icon) return "";
  const raw = String(icon).trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;

  const cleanPath = raw.replace(/^\/+/, "");
  const resolvedPath =
    cleanPath.startsWith("uploads/") || cleanPath.startsWith("icons/")
      ? cleanPath
      : `uploads/${cleanPath}`;

  return `${APP_ICON_CDN_BASE}/${resolvedPath}`;
};

export const resolveIconWithFallback = (preferredIcon, fallbackIcon) => {
  const primary = normalizeIconUrl(preferredIcon);
  const fallback = normalizeIconUrl(fallbackIcon);
  return {
    primaryIcon: primary || fallback || "",
    fallbackIcon: fallback || "",
  };
};
